import { render, staticRenderFns } from "./NewsInnerTitle.vue?vue&type=template&id=6abf52f2&"
import script from "./NewsInnerTitle.vue?vue&type=script&lang=js&"
export * from "./NewsInnerTitle.vue?vue&type=script&lang=js&"
import style0 from "./NewsInnerTitle.vue?vue&type=style&index=0&id=6abf52f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports